import get from "lodash.get";
import { LoggerService as lgg } from "vue-components-library";

import { REQUEST_ERROR_502, REQUEST_ERROR_503, UNKNOWN_ERROR, NO_INTERNET_CONNECTION } from "@/App/store/Messages";

const LOG_TAG = "[HTTP ERROR]";

export default {
  parse: (axiosError: any) => {
    const errorMessageFromServer = get(axiosError, "response.data.message");

    lgg.info(`${LOG_TAG} Error: ${errorMessageFromServer}`, { error: axiosError });

    if (axiosError.response) {
      if (errorMessageFromServer) {
        return errorMessageFromServer;
      } else {
        let message;
        switch (axiosError.response.status) {
          case 502:
            message = REQUEST_ERROR_502;
            break;
          case 503:
            message = REQUEST_ERROR_503;
            break;
          default:
            message = UNKNOWN_ERROR;
        }
        return message;
      }
    } else {
      return NO_INTERNET_CONNECTION;
    }
  }
};

export function reThrowError(error) {
  throw error;
}
